import { jsxs as m, jsx as l } from "react/jsx-runtime";
import { c as t } from "../../clsx-OuTLNxxd.js";
import { SectionNotification as o } from "../SectionNotification/SectionNotification.js";
import '../../assets/Card.css';const g = "_card_18vam_1", a = {
  card: g,
  "card--regular": "_card--regular_18vam_7",
  "card--large": "_card--large_18vam_8",
  "card--small": "_card--small_18vam_13",
  "card-header": "_card-header_18vam_26",
  "card--high-contrast": "_card--high-contrast_18vam_33",
  "card--align-center": "_card--align-center_18vam_37"
}, v = ({
  children: d,
  header: c,
  highContrast: s,
  notification: e,
  padding: r = "regular",
  alignCenter: _ = !1
}) => /* @__PURE__ */ m(
  "div",
  {
    className: t(a.card, {
      [a["card--high-contrast"]]: s,
      [a["card--regular"]]: r === "regular",
      [a["card--small"]]: r === "small",
      [a["card--large"]]: r === "large",
      [a["card--align-center"]]: _
    }),
    children: [
      e && /* @__PURE__ */ l(o, { children: e }),
      c && /* @__PURE__ */ l("div", { className: a["card-header"], children: c }),
      d
    ]
  }
);
export {
  v as Card
};
//# sourceMappingURL=Card.js.map
